/* tslint:disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AutoMessageStatus {
  active = "active",
  draft = "draft",
  inactive = "inactive",
}

/**
 * https: // github.com/remind101/r101-api/blob/4649ee86a7132d4b21fd9236e9ff57b5906854e4/app/loaders/related_user_view.rb#L124-L138
 */
export enum ChatEligibilityState {
  eligible = "eligible",
  pending = "pending",
  unavailable = "unavailable",
  under_13 = "under_13",
  unknown = "unknown",
}

export enum ClassMembershipRole {
  owner = "owner",
  subscriber = "subscriber",
}

export enum ClassMembershipsSortDirection {
  asc = "asc",
  desc = "desc",
}

export enum ClassMembershipsSortType {
  first_name = "first_name",
  join_date = "join_date",
  joined_remind_date = "joined_remind_date",
  last_name = "last_name",
  role = "role",
}

export enum ClassSearchability {
  searchable = "searchable",
  unsearchable = "unsearchable",
}

export enum ClassType {
  district = "district",
  organization = "organization",
  owned = "owned",
  pending = "pending",
  subscribed = "subscribed",
}

export enum ComposerMessageType {
  announcement = "announcement",
  conversation = "conversation",
  urgent_announcement = "urgent_announcement",
}

export enum ContactabilityStatus {
  ghost = "ghost",
  poor = "poor",
  rich = "rich",
  uncontactable = "uncontactable",
}

export enum DeliverySummaryUnidentifiableReason {
  missing_parents = "missing_parents",
  missing_student = "missing_student",
}

export enum DeviceType {
  apns = "apns",
  email = "email",
  gcm = "gcm",
  landline = "landline",
  sms = "sms",
}

export enum LegacyMessageStatus {
  failed = "failed",
  pending = "pending",
  received = "received",
  scheduled = "scheduled",
  sent = "sent",
}

export enum LegacyUserRole {
  parent = "parent",
  student = "student",
  teacher = "teacher",
}

export enum MessageRecipientsRole {
  admin = "admin",
  everyone = "everyone",
  parent = "parent",
  student = "student",
  teacher = "teacher",
}

export enum OrgPermission {
  can_send_auto_message = "can_send_auto_message",
}

export enum OrgRole {
  admin = "admin",
  everyone = "everyone",
  parent = "parent",
  rce = "rce",
  student = "student",
  teacher = "teacher",
  unknown = "unknown",
}

export enum OrganizationRole {
  admin = "admin",
  parent = "parent",
  rce = "rce",
  student = "student",
  teacher = "teacher",
}

export enum OrganizationRoleOrUnknown {
  admin = "admin",
  parent = "parent",
  rce = "rce",
  student = "student",
  teacher = "teacher",
  unknown = "unknown",
}

/**
 * https: // github.com/remind101/r101-api/blob/8d1121436a6ae5e5f955330dd31b3209fc2f1e82/app/loaders/organization.rb#L25
 */
export enum OrganizationType {
  District = "District",
  School = "School",
}

export enum ParticipantMessagingState {
  open = "open",
  ownerOrSameRole = "ownerOrSameRole",
  ownersOnly = "ownersOnly",
}

/**
 * TODO: Remove. Old Reachability
 */
export enum ReachabilityMedium {
  Email = "Email",
  Landline = "Landline",
  Mobile = "Mobile",
  Text = "Text",
  Web = "Web",
}

export enum ReachabilityState {
  active = "active",
  unreachable = "unreachable",
}

export enum ReachabilityStatus {
  poor = "poor",
  rich = "rich",
  unreachable = "unreachable",
}

export enum RoleBasedMessagingAudience {
  admin = "admin",
  everyone = "everyone",
  parent = "parent",
  student = "student",
  teacher = "teacher",
}

export enum SftpFeature {
  AutoMessaging = "AutoMessaging",
}

export enum SisSyncIssueSeverity {
  alert = "alert",
  error = "error",
}

/**
 * Can be any of the types returned by /v2/devices.
 */
export enum SubscriptionMedium {
  apns = "apns",
  email = "email",
  gcm = "gcm",
  landline = "landline",
  sms = "sms",
  web = "web",
}

export enum UserSelectedRole {
  admin = "admin",
  parent = "parent",
  student = "student",
  teacher = "teacher",
}

export interface AddRemoveAdminInput {
  organizationId: number;
  userUuid: string;
}

export interface AddUsersToGroupInput {
  groupUuid: string;
  uuids: string[];
}

export interface ApproveGroupMembershipRequestsInput {
  groupUuid: string;
  requestUuids: string[];
}

export interface ApproveRoleRequestsInput {
  organizationUuid: string;
  uuids: string[];
}

export interface AutoMessageContentInput {
  body: string;
  fileAttachmentUuids?: (string | null)[] | null;
}

export interface AutoMessageSenderInput {
  uuid: string;
  type: string;
}

export interface CancelGroupMembershipRequestInput {
  groupUuid: string;
}

export interface CreateOrganizationUnauthedInput {
  name: string;
  city: string;
  state: string;
  country?: string | null;
  type: OrganizationType;
  clientUuid: string;
}

export interface DeleteAutoMessageInput {
  uuid: string;
}

export interface DeliveryReportInput {
  streamUuid: string;
  messageUuid: string;
}

export interface DenyGroupMembershipRequestsInput {
  groupUuid: string;
  requestUuids: string[];
}

export interface DenyRoleRequestsInput {
  organizationUuid: string;
  denials: RoleRequestDenial[];
}

export interface DirectAddAdminInput {
  organizationId: number;
  name: string;
  email: string;
}

export interface EditFeatureSftpCredentialsInput {
  orgUuid: string;
  username: string;
  displayName: string;
  featureName: SftpFeature;
}

export interface GenerateFeatureSftpCredentialsInput {
  orgUuid: string;
  displayName: string;
  featureName: SftpFeature;
}

export interface JoinGroupByCodeInput {
  groupCode: string;
  message?: string | null;
}

export interface LinkPreviewInput {
  url: string;
  title: string;
  description?: string | null;
  image?: string | null;
  image_width?: string | null;
  image_height?: string | null;
  rich_content_type?: string | null;
  rich_content_url?: string | null;
}

export interface MessageInput {
  body?: string | null;
  fileUuids?: string[] | null;
  linkPreviews?: LinkPreviewInput[] | null;
  urgent?: boolean | null;
}

export interface MessageTargetFilterInput {
  roles?: MessageRecipientsRole[] | null;
}

export interface PutMessageInput {
  uuid?: string | null;
  recipients: RecipientInput[];
  message: MessageInput;
  sender?: SenderInput | null;
}

export interface PutStudentIdListInput {
  uuid: string;
  fileUuid: string;
  organizationUuid: string;
  includeParents?: boolean | null;
  includeStudents?: boolean | null;
}

export interface RecipientInput {
  type: string;
  uuid: string;
  role?: MessageRecipientsRole | null;
  filters?: MessageTargetFilterInput[] | null;
}

export interface RemoveGroupFromOrgInput {
  groupUuid: string;
  organizationUuid: string;
  reason?: string | null;
}

export interface RemoveUsersFromGroupInput {
  groupUuid: string;
  ids: number[];
}

export interface RequestAccessForPaidUpsellInput {
  organizationUuid: string;
  context: string;
  adminReferrals?: string[] | null;
  permissionToUseName: boolean;
}

export interface ResendUnclaimedNotificationInput {
  orgUuid: string;
}

export interface RevokeFeatureSftpCredentialsInput {
  orgUuid: string;
  featureName: SftpFeature;
  username: string;
}

export interface RoleRequestDenial {
  uuid: string;
  message?: string | null;
}

export interface SaveAutoMessageInput {
  uuid?: string | null;
  messageName?: string | null;
  csvName?: string | null;
  orgUuid?: string | null;
  creatorOrgUuid?: string | null;
  includeParents?: boolean | null;
  includeStudents?: boolean | null;
  sender?: AutoMessageSenderInput | null;
  messageContent?: AutoMessageContentInput | null;
  sftpCredentialsUsername?: string | null;
  customMessageFields?: string[] | null;
  isUrgent?: boolean | null;
}

export interface ScheduleMessageInput {
  messageInput: PutMessageInput;
  sendAt?: string | null;
}

export interface SchoolMappingInput {
  schoolId: string;
  remindSchoolUuid: string;
}

export interface SendActivationNotificationsInput {
  orgUuid: string;
  roles: string[];
}

export interface SenderInput {
  type: string;
  uuid: string;
}

export interface SetAutoMessageStatusInput {
  uuid: string;
  status: AutoMessageStatus;
}

export interface SetOrgSettingsInput {
  orgUuid: string;
  orgRequestToJoinEnabledDefault: boolean;
  orgSearchabilityDefault: ClassSearchability;
  orgParticipantMessagingDefault: ParticipantMessagingState;
  backfillExistingClasses: boolean;
}

export interface SetRequestToJoinInput {
  groupUuid: string;
  enabled: boolean;
}

export interface SetRosteringEnforcementInput {
  orgUuid: string;
  allowedToLeave: boolean;
}

export interface UpdateClassSettingsScreenInput {
  organizationUuid?: string | null;
  className?: string | null;
  classCode?: string | null;
  willOnlyMessage13AndOlder?: boolean | null;
  requestToJoinEnabled?: boolean | null;
  searchability?: ClassSearchability | null;
  participantMessagingState?: ParticipantMessagingState | null;
  isSearchable?: boolean | null;
}

export interface UpdateContentSourceProviderInput {
  title: string;
  providerIconUrl: string;
  organizationUUID: string;
  contentWebhookUrl: string;
  enabledByProvider: boolean;
  bigPreviewWebhookUrl: string;
  productLongDescription: string;
  productShortDescription: string;
}

export interface UpdateLinkedAccountProviderOauthConfigInput {
  authUrl: string;
  clientId: string;
  tokenUrl: string;
  scopes: string[];
  providerKey: string;
  clientSecret: string;
  organizationUUID: string;
}

export interface UpdateSchoolMappingsInput {
  districtUuid: string;
  schools: SchoolMappingInput[];
}

export interface UpdateUserNoteInput {
  userId: number;
  note: string;
}

/**
 * Some ACI setup do not require configs, for example Schoology.
 */
export interface UpsertAdminControlledIntegrationInput {
  config?: UpsertAdminControlledIntegrationInputConfig | null;
  initialIntegrationKey?: string | null;
  enabledByOrg?: boolean | null;
}

export interface UpsertAdminControlledIntegrationInputConfig {
  clientID: string;
  clientSecret: string;
  installationURLDomain: string;
}

export interface addDeviceToUserInput {
  userId: string;
  address: string;
}

export interface deleteLTIInput {
  organizationUUID: string;
  serviceKey: string;
}

export interface rotateLTICredentialsInput {
  organizationUUID: string;
  serviceKey: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
